
var convert = require('xml-js');

function parseXMLtoJS(xml) {
    let result1 = convert.xml2js(xml, {compact:true, spaces:2});
    return result1;
}

export { parseXMLtoJS };

